<script setup lang="ts">
import Offline from "@/components/UI/Offline.vue";
</script>

<template>
  <Offline :label="$t('page.not.available.offline')"></Offline>
</template>

<style lang="scss" scoped></style>
